"use client";
import { Button, Input, Label } from "cy-fe";
import { NextLink } from "cy-fe";
import type { FormEvent } from "react";
import { useState } from "react";
import * as StepWizard from "cy-ui/components/StepWizard";
import {
  HeaderText,
  HeaderDescription,
} from "cy-remittance/components/HeaderText";
import { BodyContainer } from "cy-remittance/components/layouts";

export function EmailPage({
  initialEmail,
  onContinue,
  signInUrl,
  createAccountHeader = "Create your account",
}: {
  initialEmail?: string;
  signInUrl: string;
  onContinue: (email: string) => Promise<void>;
  createAccountHeader?: string;
}) {
  const [submitting, setSubmitting] = useState(false);
  const [email, setEmail] = useState(initialEmail || "");
  async function submitHandler(evt: FormEvent) {
    evt.preventDefault();
    if (email) {
      setSubmitting(true);
      try {
        await onContinue(email);
      } catch (err) {
        // noop
      } finally {
        setSubmitting(false);
      }
    }
  }
  return (
    <StepWizard.StepPageLayout
      headerRender={() => (
        <HeaderText vCenter>{createAccountHeader}</HeaderText>
      )}
    >
      <div className="px-5">
        <HeaderDescription>
          Already have an account?{" "}
          <NextLink
            className="font-semibold text-black underline underline-offset-2"
            href={signInUrl}
          >
            {" "}
            Log in
          </NextLink>
        </HeaderDescription>
        <form onSubmit={submitHandler}>
          <BodyContainer className="mt-10">
            <Label>First, enter your email address</Label>
            <Input
              onChange={(e) => setEmail(e.target.value)}
              required
              type="email"
              vSize="lg"
              value={email}
            />
            <Button className="mt-10 w-full" loading={submitting} vSize="lg">
              Next
            </Button>
          </BodyContainer>
        </form>
      </div>
    </StepWizard.StepPageLayout>
  );
}
